import clsx from 'clsx';
import React from 'react';

import styles from './Checkbox.module.scss';

interface ICheckboxProps {
  checked?: boolean;
  className?: string;
  disabled?: boolean;
}

const Checkbox: React.FC<ICheckboxProps> = ({ checked, className, disabled }) => {
  return (
    <svg
      className={clsx(styles.svg, disabled && styles.disabled, checked && styles.checked, className)}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect className={styles.bg} width="24" height="24" rx="2" />
      <path
        className={styles.border}
        d="M22 0a2 2 0 012 2v20a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h20zm0 1H2a1 1 0 00-.993.883L1 2v20a1 1 0 00.883.993L2 23h20a1 1 0 00.993-.883L23 22V2a1 1 0 00-.883-.993L22 1z"
      />
      <path className={styles.checker} d="M18.297 6L19.696 7.399 9.6 17.496 4 11.896 5.4 10.496 9.6 14.696z" />
    </svg>
  );
};

export default Checkbox;
